import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { isBICValid, isIBANValid, nameIsValid } from '@@viewHelpers/validations';
import { equals, not } from 'ramda';
import { ControlledInput } from '@@viewCommonComponents/controlled';
import { InfoMessage } from '@fasstech/middle-design-system';
import React from 'react';

const BankInformations = ({ fieldsPrefix, getMiddleText, getMiddleBoolean, isCustomer }) => {
  const form = useFormContext();
  const bankAccountType = form.watch('bankAccounts.0.type');

  const paymentInformationComponent = equals(fieldsPrefix, 'paymentInformations');

  // The field is required if the client is not a customer, or the payment type is 'PRELEVEMENT'/'VIREMENT, or the CMS/Cockpit is true

  const isFieldRequired =
    !isCustomer ||
    equals('PRELEVEMENT', bankAccountType) ||
    equals('VIREMENT', bankAccountType) ||
    getMiddleBoolean('PAIEMENTETREMBOURSEMENT_REMBOURSEMENT_EST_OBLIGATOIRE');

  return (
    <>
      {paymentInformationComponent && (
        <div>
          <ControlledInput
            name={`${fieldsPrefix}.ownerName`}
            label={getMiddleText('PAIEMENTETREMBOURSEMENT_ACCOUNT_OWNER_LABEL')}
            form={form}
            rules={nameIsValid(isFieldRequired)}
            disabled={true}
            data-testid="ACCOUNT_OWNER_NAME"
          />

          <div className="mt-4">
            <InfoMessage>
              {getMiddleText('PAIEMENTETREMBOURSEMENT_ACCOUNT_NAME_INFO_TEXT')}
            </InfoMessage>
          </div>
        </div>
      )}

      {not(paymentInformationComponent) && (
        <ControlledInput
          name={`${fieldsPrefix}.ownerName`}
          label={getMiddleText('PAIEMENTETREMBOURSEMENT_ACCOUNT_OWNER_LABEL')}
          form={form}
          rules={nameIsValid(isFieldRequired)}
          data-testid="ACCOUNT_OWNER_NAME"
        />
      )}

      <ControlledInput
        name={`${fieldsPrefix}.iban`}
        label={getMiddleText('PAIEMENTETREMBOURSEMENT_ACCOUNT_IBAN_LABEL')}
        form={form}
        mask="aa** **** **** **** **** **** ***"
        maskPlaceholder="_"
        rules={isIBANValid(isFieldRequired)}
        data-testid="ACCOUNT_IBAN"
      />

      <ControlledInput
        name={`${fieldsPrefix}.bic`}
        label={getMiddleText('PAIEMENTETREMBOURSEMENT_ACCOUNT_BIC_LABEL')}
        form={form}
        rules={isBICValid(isFieldRequired)}
        data-testid="ACCOUNT_BIC"
      />

      <ControlledInput
        name={`${fieldsPrefix}.bankName`}
        label={getMiddleText('PAIEMENTETREMBOURSEMENT_ACCOUNT_BANK_LABEL')}
        form={form}
        rules={nameIsValid(isFieldRequired)}
        data-testid="ACCOUNT_BANK"
      />
    </>
  );
};

BankInformations.propTypes = {
  fieldsPrefix: PropTypes.string,
  getMiddleBoolean: PropTypes.func,
  isCustomer: PropTypes.bool,
  getMiddleText: PropTypes.func
};

export default BankInformations;
